import friendsApi from '../../api/radarFriends';
import {
  clearFriendSearch,
  radarConnectionsSelector,
  setSearch,
  setSearchedFriend,
} from './slice';

const CHARACTER_SET = '0123456789ABCDEFGHJKLMNPQRSTUVWXYZ';
const uidRegex = new RegExp(
  `^[${CHARACTER_SET}]{5}-[${CHARACTER_SET}]{5}-[${CHARACTER_SET}]{5}`,
);

// eslint-disable-next-line import/prefer-default-export
export const searchFriend = (phrase) => async (dispatch, getState) => {
  const state = getState();
  const {
    auth: { token },
    radarUserProfile: { userData: { id: myId } = {} },
  } = state;

  const { searchedFriend: oldSearchedFriend } = radarConnectionsSelector(state);

  if (!token) {
    return;
  }

  dispatch(setSearch(phrase));

  if (!uidRegex.test(phrase)) {
    if (oldSearchedFriend) {
      dispatch(clearFriendSearch());
    }
  } else {
    let searchedFriend = null;
    try {
      searchedFriend = await friendsApi.fetchPlayer(
        token,
        phrase,
        'friendcode',
      );
    } catch {
      //
    }

    if (
      !searchedFriend ||
      !searchedFriend.cuid ||
      searchedFriend.cuid === myId ||
      searchedFriend.status === 'hidden'
    ) {
      if (oldSearchedFriend) {
        dispatch(clearFriendSearch());
      }
      return;
    }

    dispatch(setSearchedFriend(searchedFriend));
  }
};
